<template>
  <div class="summary" id="game_summary">
    <div style="margin: 20px;">
      <div style="margin: 0px;">
          <img :src="`${publicPath}img/TimberLoungeBanner-sm.png`" style="width: 100%;"/>
      </div>
      <div v-if="this.summary != null" class="has-text-centered">
        <h3 v-if="summary.title != ''" class="is-size-3">{{ summary.title }}</h3>
        <h3 v-else class="is-size-3">Game</h3>
        <p>{{ (summary.league != null && summary.league != '' ? '(' + summary.league.trim() + ')' : '') }}</p>
        <p>{{ summary.dateTimeStamp | formatDateTimeLongFull }}</p>
      </div>
      <div>
        <h2 class="is-size-4">Round-Robin</h2>
        <br/>
        <SummaryTable :summary="summary" :players="this.playersSortedByTotal_RoundRobin" :isFinals="false"/>
        <br/>
        <SummaryBrackets :brackets="this.generateRoundRobinBrackyData"/>
        <br/>
        <h2 class="is-size-4">Accolades</h2>
        <br/>
        <SummaryAccolades :summary="summary" :accolades="this.accolades_RoundRobin" :isFinals="false"/>
      </div>
    </div>
   
    <div style="break-before: page; margin: 20px;">
      <div v-if="hasFinals">
        <br/>
        <h2 class="is-size-4">Finals</h2>
        <br/>
        <SummaryTable :summary="summary" :players="this.playersSortedByTotal_Finals" isFinals="true"/>
        <br/>
        <SummaryBrackets :brackets="this.generateFinalsBrackyData"/>
      </div>
      <br/>
      <div class="columns is-mobile" style="margin: 0px;">
        <div class="column" style="border: none; padding: 0px;">
          <div>
            <h2 class="is-size-4">Trendlines</h2>
            <br/>
            <div class="columns is-mobile" style="margin: 0px;">
              <div class="column" style="display: inline; float: left; padding: 0px 8px 0px 0px; border: none;">
                <div v-for="(player, index) in this.playersSortedByTotal_RoundRobin" :key="player.player" class="sparkline_div" style="padding: 4px; border: solid black 1px; margin: 2px; font-size: 0.8em;">
                    <p>{{ player.given_name || player.name}}</p>
                    <sparkline
                      v-bind:data=getTrendlineOfScores(player)>
                    </sparkline>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .tournament-bracket__round {
    max-width: 200px;
  }
  .tournament-bracket__list {
    max-width: 200px;
  }
  .tournament-bracket__item {
    max-width: 200px;
  }
  .tournament-bracket__match {
    font-size: 0.8em;
    border-radius: 15px;
    border: solid black 1px;
    max-width: 200px;
    min-height: 40px;
  }
  .tournament-bracket__round-title {
    display: none;
    /*
    height: 3px !important;
    color: black !important;
    */
  }
  .tournament-bracket__item {
    padding: 0px;
  }
</style>

<style scoped="true">
  .summary {
    color: black !important;
    max-width: 820px;
    margin: auto;
  }
  .game_summary h1,h2,h3,h4,h5,h6 {
    color: black !important;
  }
  .sparkline_div {
    display: inline-block;
    padding: 20px;
  }
  .column {
    border: solid lightgray 1px;
  }
  .match {
    border: solid black 4px;
    border-radius: 25px;
    padding: 10px;
    margin: 10px;
  }
  .match .matchWinner {
    color: yellow;
  }
  .col_adjust {
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 0.9em;
  }
</style>

<script>
import SummaryAccolades from "./SummaryAccolades.vue";
import SummaryTable from "./SummaryTable.vue";
import SummaryBrackets from "./SummaryBrackets.vue";
import Sparkline from "../components/Sparkline";

export default {
  name: "SummaryModal",
  props: {
    summary: null
  },
  components: {
    SummaryAccolades,
    SummaryTable,
    SummaryBrackets,
    Sparkline
  },  
  data () {
    return {
      publicPath: process.env.BASE_URL,
      players: null
    }
  },
  computed: {
    hasFinals() {
      var finals = this.getFinals();
      return (finals.length == 0 ? false : true);  
    },
    generateRoundRobinBrackyData() {
      var rounds = this.getRounds()
      
      if (rounds) {
        rounds = rounds.filter(round => round.Type != 'Finals');
        if (rounds.length >= 2) rounds = rounds.slice(-2);
        var brackyData = this.generateBrackyData(rounds);
        return brackyData;
      }
      return [];
    },
    generateFinalsBrackyData() {
      var finals = this.getFinals();

      if (finals.length >= 4) finals = finals.slice(-4);
      else if (finals.length >= 3) finals = finals.slice(-3);
      else if (finals.length >= 2) finals = finals.slice(-2);

      var brackyData = this.generateBrackyData(finals);
      return brackyData;
    },
    accolades_RoundRobin() {
      return {
        finalsChamp: this.calculateFinalsChamp(),
        mostImproved: this.calculateMostImproved('Round-Robin'),
        mostConsecutiveBulls: this.calculateMostConsecutiveBulls('Round-Robin'),
        mostThrees: this.calculateMostThrees('Round-Robin'),
        totalBullsEyes: this.calculateTotalBullsEyes('Round-Robin'),
        mostBullsEyes: this.calculateMostBullsEyes('Round-Robin'),
        bestScore: this.calculateBestScore('Round-Robin')
      }
    },
    accolades_Finals() {
      return {
        finalsChamp: this.calculateFinalsChamp(),
        mostImproved: this.calculateMostImproved('Finals'),
        mostConsecutiveBulls: this.calculateMostConsecutiveBulls('Finals'),
        mostThrees: this.calculateMostThrees('Finals'),
        totalBullsEyes: this.calculateTotalBullsEyes('Finals'),
        mostBullsEyes: this.calculateMostBullsEyes('Finals'),
        bestScore: this.calculateBestScore('Finals')
      }
    },
    playersSortedByTotal_RoundRobin() {
      if (this.summary != null && this.summary.players != null) {
        for (var i = 0; i < this.summary.players.length; i++) {
          this.summary.players[i].total = this.calculateTotalThrows(this.summary.players[i],this.summary,'Round-Robin');
          this.summary.players[i].average = this.calculateAverageThrow(this.summary.players[i],this.summary,'Round-Robin');
          this.summary.players[i].bullseyes = this.calculateTotalBullseyes2(this.summary.players[i],this.summary,'Round-Robin');
          this.summary.players[i].wins = this.calculateTotalWins(this.summary.players[i],this.summary,'Round-Robin');
          this.summary.players[i].loss = this.calculateTotalLoss(this.summary.players[i],this.summary,'Round-Robin');
          this.summary.players[i].gp = this.calculateTotalGP(this.summary.players[i],this.summary,'Round-Robin');
          this.summary.players[i].sparkine = this.createSparklineData(this.summary.players[i],this.summary,'Round-Robin');
        }
        var playersArr = this.cloneAsObject(this.summary.players);
        playersArr = playersArr.filter(item => item.name !== "");

        playersArr.sort(function(a, b){
          let x = parseInt(a.total);
          let y = parseInt(b.total);
          if (x < y) {return 1;}
          if (x > y) {return -1;}
          return 0;
        });
        return playersArr;
      }
      return null;
    },
    playersSortedByTotal_Finals() {

      if (this.summary.players != null) {

        let playerList = this.cloneAsObject(this.summary.players);

        for (var i = 0; i < playerList.length; i++) {
          playerList[i].total = this.calculateTotalThrows(playerList[i],this.summary,'Finals');
          playerList[i].average = this.calculateAverageThrow(playerList[i],this.summary,'Finals');
          playerList[i].bullseyes = this.calculateTotalBullseyes2(playerList[i],this.summary,'Finals');
          playerList[i].wins = this.calculateTotalWins(playerList[i],this.summary,'Finals');
          playerList[i].loss = this.calculateTotalLoss(playerList[i],this.summary,'Finals');
          playerList[i].gp = this.calculateTotalGP(playerList[i],this.summary,'Finals');
          playerList[i].sparkine = this.createSparklineData(playerList[i],this.summary,'Finals');
        }
        var playersArr = this.cloneAsObject(playerList);
        playersArr = playersArr.filter(item => item.name !== "");

        playersArr.sort(function(a, b){
          let x = parseInt(a.total);
          let y = parseInt(b.total);
          if (x < y) {return 1;}
          if (x > y) {return -1;}
          return 0;
        });

        playersArr = playersArr.filter(plyr => plyr.gp != 0);
        //this.players = playersArr;
        
        return playersArr;
      }
      return null;
    }
  },
  methods: {
    generateBrackyData(finals) {
      var rounds = [];

      if (finals != null && finals.length != 0) {
        var newBrackyTemplate =  {
          player1: { id: "", name: "", winner: false, score: 0 },
          player2: { id: "", name: "", winner: false, score: 0 },
        };

        for (var i = 0; i < finals.length; i++) {
          var games = {
            games: []
          }

          var finalsRoound = finals[i];
          var matches = finalsRoound.matches;

          for (var x = 0; x < matches.length; x++) {
            var matchPlayers = matches[x].matchPlayers;
           
            var newBracky = this.cloneAsObject(newBrackyTemplate);

            newBracky.player1.id = matchPlayers[0].player.id;
            newBracky.player1.name = matchPlayers[0].player.name;
            newBracky.player1.winner = matchPlayers[0].winner;
            var p1Total = 0;
            for (var z = 0; z < matchPlayers[0].throws.length; z++) {
              p1Total += matchPlayers[0].throws[z].basicScore;
            }
            newBracky.player1.score = p1Total;
            
            newBracky.player2.id = matchPlayers[1].player.id;
            newBracky.player2.name = matchPlayers[1].player.name;
            newBracky.player2.winner = matchPlayers[1].winner;
            var p2Total = 0;
            for (var z = 0; z < matchPlayers[1].throws.length; z++) {
              p2Total += matchPlayers[1].throws[z].basicScore;
            }
            newBracky.player2.score = p2Total;
            
            games.games.push(newBracky)
            games.title = finalsRoound.title;
          }
          rounds.push(games);
        }
      }

      if (rounds.length != 0) {
        //keep up to 4 total final rounds
        rounds = this.getLastItems(rounds);
        rounds = this.setTitleOnRounds(rounds);
      }
      return rounds;
    },
    calculateFinalsChamp() {
      var playerName = "";
      var finals = this.getFinals();

      var finalRound = finals[finals.length-1];
      if (finalRound) {
        var finalMatch = finalRound.matches[0];
        var winnerId = finalMatch.winnerId;
        playerName = this.getPlayerName(winnerId);
      }
      return playerName;
    },
    calculateMostImproved(type) {
      var sortedIncreasingPlayers = this.getPlayersSortedByTrend(type);
      var topIncreasingPlayer = sortedIncreasingPlayers?.[0];

      if (topIncreasingPlayer) {
        var playerName = this.getPlayerName(topIncreasingPlayer.playerId);

        return playerName;
      }
      else return "n/a";
    },
    calculateMostConsecutiveBulls(type) {
      var gameType = this.summary.gameType;
      var playerData = {
        "players": []
      };

      if (this.summary) {
        var players = this.getPlayers();

        for (var i = 0; i < players.length; i++) {
          var plyr = players[i];
          var thrwList = this.getArrayOfScores(plyr,type); 
          var playerId = plyr.id;
          var consecutiveBulls = this.countMaxConsecutiveFives(thrwList);

          playerData.players.push({ "id": playerId, "consecutiveBulls": consecutiveBulls });        
        }
      }
      var playerDataSorted = playerData.players.sort((a, b) => b.consecutiveBulls - a.consecutiveBulls);

      var mostCons = "";
      if (gameType === 'Solo') {
        mostCons = playerDataSorted[0].consecutiveBulls;
      } else {
        if (playerDataSorted[0] && playerDataSorted[0].consecutiveBulls != 0 && playerDataSorted[0].consecutiveBulls != 1) {
          mostCons = this.getPlayerName(playerDataSorted[0]?.id) + " (" + playerDataSorted[0].consecutiveBulls + ")";
        } else {
          mostCons = "n/a";        
        }
      }

      return mostCons;
    },
    /*
    calculateLeastImproved() {
      var sortedIncreasingPlayers = this.getPlayersSortedByTrend();
      var leastIncreasingPlayer = sortedIncreasingPlayers?.[sortedIncreasingPlayers.length-1];
      var playerName = this.getPlayerName(leastIncreasingPlayer.playerId);

      return playerName + " (" + leastIncreasingPlayer.trend.toFixed(2) + ")";
    },
    */
    calculateMostThrees(type) {
      var threesArray = [];
      if (this.summary) {
        var players = this.getPlayers();
        if (players != null && players.length !=0) {
          if (players != null && players.length != 0) {
            for (var i = 0; i < players.length; i++) {
              var playerId = players[i].id;
              var playerThrees = this.getThrees(playerId,type);
              threesArray.push({ "id": playerId, "threes": playerThrees });
            }
          }
        }
      }
      var threesArraySorted = threesArray.sort((a, b) => b.threes - a.threes);
      return this.getPlayerName(threesArraySorted[0]?.id) + " (" + threesArraySorted[0]?.threes + ")";
    },
    calculateTotalBullsEyes(type) {
      var playerBulls = 0;
      if (this.summary && this.summary.players) {
        var playerId = this.summary.players[0].id;
        playerBulls = this.getBulls(playerId,type);
      }
      return playerBulls;
    },
    calculateMostBullsEyes(type) {
      var bullsArray = [];
      if (this.summary) {
        var players = this.getPlayers();
        for (var i = 0; i < players.length; i++) {
          var playerId = players[i].id;
          var playerBulls = this.getBulls(playerId,type);
          bullsArray.push({ "id": playerId, "bulls": playerBulls });
        }
      }
      var bullsArraySorted = bullsArray.sort((a, b) => b.bulls - a.bulls);

      if (bullsArraySorted[0]?.bulls == 0) return "n/a";
      else return this.getPlayerName(bullsArraySorted[0]?.id) + " (" + bullsArraySorted[0]?.bulls + ")";
    },
    calculateBestScore(type) {
      var bestArray = [];
      if (this.summary) {
        var players = this.getPlayers();
        for (var i = 0; i < players.length; i++) {
          var playerId = players[i].id;
          var playerTotal = this.getTotal(playerId,type);
          bestArray.push({ "id": playerId, "total": playerTotal });
        }
      }
      var bestArraySorted = bestArray.sort((a, b) => b.total - a.total);
      var displayText = this.getPlayerName(bestArraySorted[0]?.id) + " (" + bestArraySorted[0]?.total + ")";
      return displayText;
    },
    calculateAverageThrow(player, summary, type) {
      if (player != null) {
        var rounds = summary.rounds.filter(round => round.type === type);
        var total = 0;
        var count = 0;
        rounds.forEach((round) => {
          round.matches.forEach((match) => {
            var myMatch = match.matchPlayers.filter((matchPlayer) => matchPlayer.id === player.id);
            if (myMatch[0]) {
              myMatch[0].throws.forEach((thrw) => { 
                total += thrw.basicScore;
                count++;
              })
            }
          });
        });
        var avg = total / count;
        return avg.toFixed(2);
      }
      return 0;
    },
    calculateTotalThrows(player, summary, type) {
      if (player != null) {
        var rounds = summary?.rounds.filter(round => round.type === type);
        var total = 0;
        rounds.forEach((round) => {
          round.matches.forEach((match) => {
            var myMatch = match.matchPlayers.filter((matchPlayer) => matchPlayer.id === player.id);
            if (myMatch[0]) {
              myMatch[0].throws.forEach((thrw) => { 
                total += thrw.basicScore;
              })
            }
          });
        });
        return total;
      }
      return 0;
    },
    calculateTotalBullseyes2(player, summary, type) {
      if (player != null) {
        var rounds = summary.rounds.filter(round => round.type === type);
        var total = 0;
        rounds.forEach((round) => {
          round.matches.forEach((match) => {
            var myMatch = match.matchPlayers.filter((matchPlayer) => matchPlayer.id === player.id);
            if (myMatch[0]) {
              myMatch[0].throws.forEach((thrw) => { 
                if (thrw.isBullsEye) total++;
              })
            }
          });
        });
        return total;
      }
      return 0;
    },
    calculateTotalWins(player, summary, type) {
      if (player != null) {
        var rounds = summary.rounds.filter(round => round.type === type);
        var total = 0;
        rounds.forEach((round) => {
          round.matches.forEach((match) => {
            var myMatch = match.matchPlayers.filter((matchPlayer) => matchPlayer.id === player.id);
            if (myMatch[0] && myMatch[0].winner) total++;
          });
        });
        return total;
      }
      return 0;
    },
    calculateTotalLoss(player, summary, type) {
      if (player != null) {
        var rounds = summary.rounds.filter(round => round.type === type);
        var total = 0;
        rounds.forEach((round) => {
          round.matches.forEach((match) => {
            var myMatch = match.matchPlayers.filter((matchPlayer) => matchPlayer.id === player.id);
            if (myMatch[0] && !myMatch[0].winner) total++;
          });
        });
        return total;
      }
      return 0;
    },
    calculateTotalGP(player, summary, type) {
      if (player != null) {
        var rounds = summary.rounds.filter(round => round.type === type);
        var total = 0;
        rounds.forEach((round) => {
          round.matches.forEach((match) => {
            var myMatch = match.matchPlayers.filter((matchPlayer) => matchPlayer.id === player.id);
            if (myMatch[0]) total++;
          });
        });
        return total;
      }
      return 0;
    },
    createSparklineData(player, summary, type) {
      var data = [];
      return data;
    },
    setTitleOnRounds(rounds) {
      for (let index = rounds.length - 1; index >= 0; index--) {
        if (index == rounds.length -1) {
          rounds[index].title = "Finals";
        } else if (index == rounds.length -2) {
          rounds[index].title = "Semis";
        } else if (index == rounds.length -3) {
          rounds[index].title = "Quarter";
        } else if (index == rounds.length -4) {
          rounds[index].title = "Eliminations";
        }
      }
      return rounds;
    },
    getLastItems(rounds) {
      // Check the length of the array and determine the number of items to return
      const numItems = rounds.length >= 4 ? 4 : rounds.length;
      // Use the slice method to get the last items
      return rounds.slice(-numItems);
    },    
    countMaxConsecutiveFives(arr) {
        let maxCount = 0; // Holds the maximum count of consecutive 5's
        let currentCount = 0; // Tracks the current count of consecutive 5's

        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === 5) {
                // Increment current count if the current element is 5
                currentCount++;
                // Update maxCount if currentCount is greater
                maxCount = Math.max(maxCount, currentCount);
            } else {
                // Reset current count if the current element is not 5
                currentCount = 0;
            }
        }
        return maxCount;
    },
    getFinals() {
      var rounds = [];
      if (this.summary.gameType === "Round-Robin") {
        rounds = this.summary?.rounds?.filter((round) => round.type == "Finals");
      } else {
        var allRounds = this.getRounds();
        if (allRounds != null && allRounds.length != 0) {
          allRounds.forEach(r => {
            if (r.type === "Finals") {
              rounds.push(r);
            }
          });
        }
      }
      return rounds;
    },
    getRounds() {
      var rounds = [];
      if (this.summary.gameType === 'Tournament') {
        var sets = this.summary?.sets;
        if (sets != null) {
          sets.forEach(s => {
            s.rounds.forEach(r => {
              rounds.push(r);
            });
          });
        }
      } else {
        rounds = this.summary?.rounds;
      }
      return rounds;
    },
    getTrendlineOfScores(plyr) {
      var plyrId = plyr.id;
      var rounds = this.getRounds();
      var scores = [];
      for (var x = 0; x < rounds.length; x++) {
        var rnd = rounds[x];
        for (var y = 0; y < rnd.matches.length; y++) {
          var match = rnd.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            if (matchPlayer.id == plyrId) {
              for (var a = 0; a < matchPlayer.throws.length; a++) {
                var thrw = matchPlayer.throws[a];
                scores.push(thrw.basicScore);
              }
            }
          }
        }
      }
      return scores;
    },
    getArrayOfScores(plyr,type) {
      var plyrId = plyr.id;
      var rounds = this.getRounds();
      rounds = rounds.filter(round => round.type == type);
      var scores = [];
      for (var x = 0; x < rounds.length; x++) {
        var rnd = rounds[x];
        for (var y = 0; y < rnd.matches.length; y++) {
          var match = rnd.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            if (matchPlayer.id == plyrId) {
              for (var a = 0; a < matchPlayer.throws.length; a++) {
                var thrw = matchPlayer.throws[a];
                scores.push(thrw.basicScore);
              }
            }
          }
        }
      }
      return scores;
    },
    getPlayersSortedByTrend(type) {
      var playerData = {
        "players": []
      };

      if (this.summary) {
        var players = this.getPlayers();
        if (players != null && players.length != 0) {

          for (var i = 0; i < players.length; i++) {
            var plyr = players[i];
            var playerId = plyr.id;

            var scores = this.getArrayOfScores(plyr,type); 

            var half_length = Math.ceil(scores.length / 2);    
            var leftSide = scores.slice(0,half_length);
            
            var second_half_start = half_length;    
            var rightSide = scores.slice(second_half_start, scores.length);

            const leftTotal = leftSide.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const leftAvg = (leftTotal / leftSide.length);

            const rightTotal = rightSide.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            const rightAvg = (rightTotal / rightSide.length);

            var trend = rightAvg / leftAvg;
            
            playerData.players.push({"playerId": playerId, "trend" : trend });
          }

        }
      }
      var increasingPlayers = playerData.players.filter((p) => p.trend > 1);
      var sortedIncreasingPlayers = increasingPlayers.sort((a, b) => b.trend - a.trend);
      return sortedIncreasingPlayers;
    },
    getPlayerName(playerId) {
      var players = this.getPlayers();
      var player = players.filter((plyr) => plyr.id == playerId);
      var playerName = player[0]?.name;
      return playerName;
    },
    getPlayers() {
      var result = [];
      if (this.summary != null && this.summary.players != null) result = this.summary.players;
      return result;
    },
    getThrees(playerId,type) {
      var total = 0;
      var rounds = this.getRounds();
      rounds = rounds.filter(round => round.type == type);
      for(var x = 0; x < rounds.length; x++) {
        var round = rounds[x];
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            if (matchPlayer.id == playerId) {
              for (var a = 0; a < matchPlayer.throws.length; a++) {
                var thrw = matchPlayer.throws[a];
                if (thrw.basicScore == 3) total++;
              }
            }
          }
        } 
      }
      return total;
    },
    getBulls(playerId,type) {
      var total = 0;
      var rounds = this.getRounds();
      rounds = rounds.filter(round => round.type == type);
      for(var x = 0; x < rounds.length; x++) {
        var round = rounds[x];
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            if (matchPlayer.id == playerId) {
              for (var a = 0; a < matchPlayer.throws.length; a++) {
                var thrw = matchPlayer.throws[a];
                if (thrw.isBullsEye || thrw.basicScore == 5) total++;
              }
            }
          }
        } 
      }
      return total;
    },
    getRoundTotal(playerId, round) {
      var total = 0;
      for (var y = 0; y < round.matches.length; y++) {
        var match = round.matches[y];
        for (var z = 0; z < match.matchPlayers.length; z++) {
          var matchPlayer = match.matchPlayers[z];
          if (matchPlayer.id == playerId) {
            for (var a = 0; a < matchPlayer.throws.length; a++) {
              var thrw = matchPlayer.throws[a];
              total += thrw.basicScore;
            }
          }
        }
      } 
      return total;
    },
    getTotal(playerId,type) {
      var total = 0;
      var rounds = this.getRounds();
      rounds = rounds.filter(round => round.type == type);
      for(var x = 0; x < rounds.length; x++) {
        var round = rounds[x];
        for (var y = 0; y < round.matches.length; y++) {
          var match = round.matches[y];
          for (var z = 0; z < match.matchPlayers.length; z++) {
            var matchPlayer = match.matchPlayers[z];
            if (matchPlayer.id == playerId) {
              for (var a = 0; a < matchPlayer.throws.length; a++) {
                var thrw = matchPlayer.throws[a];
                total += thrw.basicScore;
              }
            }
          }
        } 
      }
      return total;
    },
    analyzeArrayTrend(scores) {
        if (scores.length < 2) {
            return "Not enough data to determine the trend";
        }

        let increasing = 0;
        let decreasing = 0;

        // Calculate the total increase and decrease
        for (let i = 0; i < scores.length - 1; i++) {
            if (scores[i + 1] > scores[i]) {
                increasing += (scores[i + 1] - scores[i]);
            } else if (scores[i + 1] < scores[i]) {
                decreasing += (scores[i] - scores[i + 1]);
            }
        }

        // Determine the trend
        if (increasing > decreasing) {
            return "Overall increasing";
        } else if (decreasing > increasing) {
            return "Overall decreasing";
        } else {
            return "Staying the same";
        }
    },
    cloneAsObject: function(obj) {
      if (obj === null || !(obj instanceof Object)) {
          return obj;
      }
      var temp = (obj instanceof Array) ? [] : {};
      // ReSharper disable once MissingHasOwnPropertyInForeach
      for (var key in obj) {
          temp[key] = this.cloneAsObject(obj[key]);
      }
      return temp;
    },
    close() {
      this.$emit("close");
    }
  },
  mounted(){
    console.log("Summary mounted");
  }
};
</script>
